function Product() {
  return (
    <main className="sec-content sec-content_3">
      <div className="container-def">
        <div className="sec-content__wrap">
          <div className="product-info">
            <div className="product-info__top">
              <div className="product-info__top-left">
                <div className="product-info__title title-def title-def_sec3">Метилкремнегель, сорт второй<br/>RUTESIL® MSG</div>
              </div>
              <div className="img-dec">
                <img src={window.location.origin+"/img/14.webp"} alt="" className="img-dec__img" />
              </div>
            </div>
            <div className="product-info__content wrap-article-2">
              <h4>Описание</h4>
              <p>Метилкремнегель, сорт второй (гидролизат  метилтрихлорсилана, полиметилсилсесквиоксан) - это кремнийорганическая смола неопределенного состава в смеси с водой. Содержание смолы в продукте не менее 50%. </p>
              <p>Метилкремнегель, сорт второй  используется в производстве медицинских адсорбентов и водоотталкивающих жидкостей (гидрофобизаторов) для строительных материалов.</p>
              <p></p>
              <h4>Основные характеристики</h4>
              <p>Внешний вид: влажные гранулы белого цвета</p>
              <p>Массовая доля хлористого водорода: не более 1,0 %</p>
              <p>Растворимость в водном растворе щелочи: не менее 95 %</p>
              <p>Массовая доля сухого вещества: не менее 50 %</p>
              <p></p>
              <h4>Упаковка</h4>
              <p>Многослойные мешки, 25кг.</p>
              <p></p>
              <h4>Хранение</h4>
              <p>Продукт должен храниться в плотно закрытой таре производителя в сухом помещении. Беречь от повреждения тары, попадания атмосферных осадков и действия прямых солнечных лучей.</p>
              <p>Гарантийный срок хранения – 12 месяцев.</p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
export default Product;